var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsSecure = function SvgIconsSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.649 1.064-8 3A1 1 0 0 0 3 5v7c0 2.97 1.646 5.644 4.341 8.003a22.465 22.465 0 0 0 2.879 2.126l.547.332.449.256.337.177a1 1 0 0 0 .894 0l.337-.177.45-.256.354-.213.192-.119c.98-.612 1.96-1.323 2.879-2.126C19.354 17.643 21 14.969 21 12V5a1 1 0 0 0-.649-.936l-8-3a1 1 0 0 0-.702 0zM12 3.068l7 2.625V12c0 2.28-1.354 4.481-3.659 6.497a20.49 20.49 0 0 1-2.621 1.936l-.45.274-.27.155-.27-.155-.45-.274a20.49 20.49 0 0 1-2.621-1.936l-.262-.233C6.252 16.312 5 14.193 5 12V5.693l7-2.625z"
  })));
};
export default SvgIconsSecure;